<template>
  <div>
    <v-container>
      <v-card>
        <v-card-title class="text-xs-center project headline">Frequently Asked Questions</v-card-title>
        <v-expansion-panel v-model="panel" expand>
          <v-expansion-panel-content
            v-for="(faq, index) in indexData.faqs"
            :key="index"
          >
            <template v-slot:header>
              <div>{{ faq.question_en }}</div>
            </template>
            <v-card>
              <v-card-text class="grey lighten-3"><div v-html="faq.answer_en"></div></v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      upHere: false,
    };
  },
  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "subscriptionData",
      "error",
      "statusCode",
      "errorMsg",
      "projectId",
    ]),
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.$store.dispatch("setIndexData", ["admin-faqs"]);
    },
  },
};
</script>
<style>
.headline {
  color: white;
}
.project {
  background: #ff2e2e;
}
</style>
